
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "Coupon": [
      "HorseCoupon",
      "SportCoupon"
    ]
  }
};
      export default result;
    